// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--KzCqU";
export var link = "footer-module--link--Ofj3Q";
export var list = "footer-module--list--UqCGW";